class SizeGuideModal extends HTMLElement {
  constructor() {
    super();
    this.buttonsOpen = document.querySelectorAll('.size-guide-popup-trigger');
    this.modal = this.querySelector('.size-guide-modal');
    
    this.onKeyDown = this.handleKeyDown.bind(this);
    this.onClick = this.handleOnClick.bind(this);
    
    // There can be more than 1 when there's a Bundle
    this.buttonsOpen.forEach(btn => {
      btn.addEventListener('click', this.open.bind(this))
    })
  }

  open(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const result = $s.openModal(this.modal, 'size-guide-table-wrapper');
    if (result && result.modal) {
      result.modal.setAttribute('aria-labelledby', 'size-guide-title');
    }
  }

  close() {
    $s.closeModal();
  }

  isOpen() {
    return this.classList.contains('open');
  }

  handleKeyDown(e) {
    if (e.which == 27) { //Exit
      if(this.isOpen()){
        e.preventDefault();
        this.close();
        return false;
      }
    }
  }

  handleOnClick(e) {
    if(!this.contains(e.target)) {
      this.close();
    }
  }
}
customElements.define('size-guide-modal', SizeGuideModal);